<template>
<div class="back">
    <img class="back-img" :src="bkimg" />
    <!-- <div class="back-img"></div> -->
    <div class="back-form">
        <div class="back-form-title">订制旅游</div>
        <div class="back-form-title2">其实可以很简单</div>
        <el-form ref="form" :model="form">
            <el-form-item>
                <img class="form-icon" src="../assets/name.png" alt="">
                <input class='inputname' v-model="form.username" placeholder="请输入姓名"/>
            </el-form-item>
            <el-form-item>
                <img class="form-icon" src="../assets/phone.png" alt="">
                <input class='inputname' v-model.lazy="form.mobilephone" type="number" placeholder="请填写您的手机号" @blur='refsh()' maxlength=11/>
            </el-form-item>
            <el-form-item >
                <div class="flex">
                    <input class='inputname yzm' v-model="form.code" placeholder="请输入验证码"/>
                    <img class='yzmimg' :src='vcode' alt="">
                    <div class="refsh" @click='refsh'>点击刷新图片</div>
                </div>
            </el-form-item>
            <el-form-item class='relative'>
                <img class="form-icon" src="../assets/address.png" alt="">
                <input class='inputname'  v-model="form.destname" placeholder="感兴趣的目的地" readonly="readonly" @click='showintest()'/>
                <div class="intesting" v-show='intestshow'>
                    <div class="hot">
                        <span>{{destination.name}}</span>
                        <span :class='{activehot:index === desindex}' v-for='(des,index) in destination.data' :key='index' @click='changedes(index)'>{{des.name}}</span>
                    </div>
                    <div class="bord">
                        <div class="citys">
                            <div :class="{city:true,active:list.active,relative:true}" v-for='(list,index) in lists' :key='index' @click='selectcity(index)'>
                                {{list.name}}
                                <div class="yhot" v-show='list.hot'><img src="../static/images/hot.png" alt=""></div>
                            </div>
                        </div>
                        <div class="citys mgt20" @click='check'>
                            <div class="check" v-if='!checked'></div>
                            <img v-else src="../static/images/check.png" alt="">
                            <span class='remind'>还不确定目的地</span>
                        </div>
                    </div>
                    <div class="sure" @click='ok'>确定</div>
                </div>
            </el-form-item>
            <el-form-item>
                <img class="form-icon" src="../assets/time.png" alt="">
                <input class='inputname'  v-model="form.traveldate" placeholder="旅行天数" readonly="readonly" @click='showday()'/>
                <div class="down" v-show='dayshow'>
                    <div :class='["sel",{active:day.active}]' v-for='(day,index) in days' :key='index' @click='chossedays(index)'><div class="inner"> {{day.name}}</div> </div>
                </div>
            </el-form-item>
            <el-form-item  class='relative'>
                <img class="form-icon" src="../assets/date.png" alt="">
                <!-- <el-date-picker  v-model="form.gotime"  type="date"  placeholder="预计出发时间"> </el-date-picker> -->
                 <input class='inputname'  v-model="form.gotime" placeholder="预计出发时间" readonly="readonly" @click='timeshow()'/>
                <div class="down time" v-show='starttimeshow'>
                    <Calendar
                        ref="Calendar"
                        v-on:choseDay="choosestarttime"
                        ></Calendar>
                    </div>
            </el-form-item>
            <el-form-item>
                <img class="form-icon" src="../assets/person.png" alt="">
                 <input class='inputname'  v-model="form.peoplenum" placeholder="人数" readonly="readonly" @click='personday()'/>
                <div class="down" v-show='personshow'>
                    <div :class='["sel",{active:person.active}]' v-for='(person,index) in persons' :key='index' @click='chosseperson(index)'><div class="inner"> {{person.name}}</div> </div>
                </div>
                <!-- <el-select v-model="form.peoplenum" placeholder="人数" >
                    <el-option :label="person" :value="person" v-for='(person,index) in persons' :key='index'></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit" style="width:100%;height:49px;">请帮我订制行程</el-button>

            </el-form-item>
        </el-form>
    </div>
    <Sucess :sucess = 'sucess' v-show = 'sucessshow'></Sucess>
    <Waring v-show='wraingshow' :waring='waringword'></Waring>
    <div class="contain-box">
        <div class="contain">
            <div class="contain-title">
                <span class="fl" style="font-size:24px;color:#60676d;">您可能需要查看这些订制产品</span>
                <span  class="fr" @click='change'>换一批</span>
            </div>
            <div class="contain-content">
                    <Lists :lists="hotlists"></Lists>
                </div>
        </div>
    </div>
</div>

</template>

<script>
import bkimg from '@/assets/trave-back.png'
import {travelmade} from '@/api/order.js'
import Sucess from '@/components/sucess/ordersucess'
import Waring from '@/components/warning/warning'
import Calendar from '../components/vue-calendar-component/index'
import Lists from '@/components/ListsContent.vue'
import {getthemelist} from '@/api/theme.js'
import {sliceDate} from '@/utils/index'
import {querycontent} from '@/api/content.js'
export default {
  components: {
    Sucess,
    Waring,
    Calendar,
    Lists
  },
  data () {
    return {
      form: {
        username: '',
        mobilephone: '',
        destname: '',
        traveldate: '',
        gotime: '',
        peoplenum: ''
      },
      days: [{id: 0, name: '不确定', active: false}, {id: 0, name: '1-3天', active: false}, {id: 0, name: '4-8天', active: false}, {id: 0, name: '10-15天', active: false}, {id: 0, name: '15天以上', active: false}],
      persons: [{id: 0, name: '不确定', active: false}, {id: 0, name: '1-3人', active: false}, {id: 0, name: '4-8人', active: false}, {id: 0, name: '10-15人', active: false}, {id: 0, name: '15人以上', active: false}],
      sucess: '订制旅行申请成功，请耐心等待',
      sucessshow: false,
      waringword: '',
      wraingshow: false,
      vcode: '',
      destination: {
        name: '热门',
        data: [{key: 'yz', name: '亚洲'}, {key: 'mz', name: '美洲'}, {key: 'fz', name: '非洲'}, {key: 'dyz', name: '大洋洲'}, {key: 'hd', name: '海岛'}]
      },
      deslists: {
        yz: [
          {
            id: 0,
            name: '美洲',
            hot: true,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          }
        ],
        mz: [
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          }
        ],
        fz: [
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          }
        ],
        dyz: [
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          }
        ],
        hd: [
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '新加坡',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '美洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '北极',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '大洋洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '南极洲',
            hot: false,
            active: false
          },
          {
            id: 0,
            name: '马尔代夫',
            hot: false,
            active: false
          }
        ]
      },
      desindex: 0,
      lists: [],
      checked: false,
      intestshow: false,
      starttimeshow: false,
      dayshow: false,
      personshow: false,
      bkimg: bkimg,
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 6,
        ishot: true
      },
      hottotal: 0,
      themes: []
    }
  },
  methods: {
    onSubmit () {
      for (let key in this.form) {
        if (this.form[key].length === 0) {
          switch (key) {
            case 'username':
              this.waringword = '姓名不能为空'
              break
            case 'mobilephone':
              this.waringword = '手机号不能为空'
              break
            case 'destname':
              this.waringword = '目的地不能为空'
              break
            case 'traveldate':
              this.waringword = '旅行天数不能为空'
              break
            case 'gotime':
              this.waringword = '出发时间不能为空'
              break
            case 'peoplenum':
              this.waringword = '人数不能为空'
              break
          }
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
          return
        }
      }
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(this.form.mobilephone)) {
        this.waringword = '请输入正确手机号'
        this.wraingshow = true
        setTimeout(() => { this.wraingshow = false }, 1000)
        return
      }
      let date = new Date(this.form.gotime)
      let Y = date.getFullYear() + '/'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      let D = date.getDate() < 10 ? '0' + (date.getDate()) : (date.getDate()) + ' '
      let h = date.getHours() < 10 ? '0' + (date.getHours()) : (date.getHours())
      let m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : (date.getMinutes())
      let s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : (date.getSeconds())
      this.form.gotime = Y + M + D + h + ':' + m + ':' + s
      travelmade(this.form).then(res => {
        if (res.data.code === 200) {
          this.sucessshow = false
          this.resetform()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    resetform () {
      this.form = {
        username: '',
        mobilephone: '',
        vcode: '',
        destname: '',
        traveldate: '',
        peoplenum: '',
        gotime: ''
      }
    },
    // 刷新验证码
    refsh () {
      this.vcode = 'https://www.tripolers.com.cn/admin/vcode/vcode?tel=' + this.form.mobilephone + '&notime' + Math.random()
    },
    // 改变导航栏
    changedes (index) {
      this.desindex = index
      this.lists = this.deslists[this.destination.data[index].key]
    },
    // 选择城市
    selectcity (index) {
      this.lists[index].active = !this.lists[index].active
    },
    // 暂不确定目的地
    check () {
      this.checked = !this.checked
    },
    // 感兴趣城市显示
    showintest () {
      this.intestshow = !this.intestshow
    },
    timeshow () {
      this.starttimeshow = !this.starttimeshow
    },
    // 选择城市
    ok () {
      this.intestshow = false
      if (this.checked) {
        this.form.destname = '还不确定目的地'
      } else {
        let str = ''
        for (let i = 0; i < this.lists.length; i++) {
          if (this.lists[i].active) {
            str += this.lists[i].name + ','
          }
        }
        this.form.destname = str.substr(0, str.length - 1)
      }
    },
    // 时间格式转化
    formattime (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let a = date.getDay()
      let day = ['日', '一', '二', '三', '四', '五', '六']
      return `${y}-${m}-${d}(周${day[a]})`
    },
    // 选择时间
    choosestarttime (data) {
      this.form.gotime = this.formattime(new Date(data))
      this.starttimeshow = false
    },
    showday () {
      this.dayshow = !this.dayshow
    },
    chossedays (index) {
      for (let i = 0; i < this.days.length; i++) {
        this.days[i].active = false
      }
      this.days[index].active = true
      this.form.traveldate = this.days[index].name
      this.dayshow = false
    },
    personday () {
      this.personshow = !this.personshow
    },
    chosseperson (index) {
      for (let i = 0; i < this.persons.length; i++) {
        this.persons[i].active = false
      }
      this.persons[index].active = true
      this.form.peoplenum = this.persons[index].name
      this.personshow = false
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
        }
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 6) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    }
  },
  created () {
    this.refsh()
    this.lists = this.deslists[this.destination.data[0].key]
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    this.getthemelist()
  }
}
</script>

<style scoped>
.back{
    /* width:100%;
    height:100%; */
    position: relative;
}
.back-img{
    display:inline-block;
    width:100%;
    height:1080px;
}
.back-form{
    width:430px;
    border-radius: 10px;
    padding:20px 40px;
    box-sizing: border-box;
    background:rgba(46,51,56,0.7);
    position: absolute;
    left:350px;
    top:200px;
}
.back-form-title{
    color:#039aff;
    font-size:30px;
    text-align: center;
}
.back-form-title2{
    color:#fff;
    font-size:30px;
    margin-bottom:30px;
    text-align: center;
}
.el-select{
    width:100%
}
.form-icon{
    position: absolute;
    z-index: 1000;
    left: 12px;
    top: 14px;
    margin-right:10px;
}
.el-input__inner{
    padding:0 30px
}
.el-date-editor.el-input{
    width:100%;
}
.contain-box{
    width:100%;
    /* height:1000px; */
    background: #eee;
    padding-top:30px;
    padding-bottom:40px;
}
.contain{
    width:1280px;
    margin:0 auto;
    padding:30px 24px;
    box-sizing: border-box;
    background:#fff;

}
.contain-title{
    height:30px;
    line-height:30px;
}
.fr{
    float:right;
    cursor: pointer;
}
.fl{
    float:left;
}
.contain-content{
    display:flex;
    flex-wrap:wrap;
    width:100%;
    overflow: hidden;
    margin-top:10px;
    /* justify-content: space-between; */
}
.el-form-item {
    margin-bottom: 18px;
}
.content-item{
    width:32%;
    /* height:100px; */

    margin-right:10px;
    margin-bottom:10px;
    border:1px solid #eee;
    position: relative;
}
.content-item-img{
    width:100%;
    height:266px;
}
.content-item-word{
    width:100%;
    box-sizing: border-box;
    padding:10px;
}
.content-item-tag{
    display:flex;
    flex-wrap:wrap;
    box-sizing: border-box;
    padding:10px;
    padding-top:0px;
}
.content-item-tag-item{
    padding:5px;
    border:1px solid #039aff;
    color:#039aff;
    margin-right:10px;
    margin-bottom:5px;
    font-size:10px;
    font-style:oblique;
}
.content-item-feel{
    position: absolute;
    left:0;
    top:0;
    padding:5px;
    background:black;
    opacity: 0.5;
    color:#fff;
    font-size:9px;
}
.content-item-hot{
    background:#ffa51f;
    padding:8px 14px;
    color:#fff;
    position: absolute;
    left:0;
    top:231px;
    font-size:14px;
}
.el-input >>> .el-input__inner{
    padding-left:30px !important;
}
.flex{
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.inputname{
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 49px;
    line-height: 49px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 341px;
    padding-left:42px;
    font-size:14px;
    font-weight:300;
}
.yzm{
    width:112px;
    padding:12px;
}
.yzmimg{
    height:40px;
}
.refsh{
  cursor: pointer;
    line-height:40px;
    color:#fff;
    font-size: 14px;
    cursor:default;
}

.el-select /deep/ .el-input__inner {
    padding-left: 30px  !important;
}
.relative{
    position: relative;
}
.intesting{
    position: absolute;
    width:556px;
    background-color:rgba(255, 255, 255, 1);
    z-index:9999;
    padding:0 21px;
}
.hot{
    display: flex;
    align-items: center;
    font-size:16px;
    font-weight:400;
    color:rgba(142,148,153,1);
    line-height:47px;
    border-bottom: 1px solid #F0F0F0;
}
.hot span{
    margin-right:35px;
    cursor:default;
}
.hot span:nth-of-type(1){
    color:rgba(67,69,71,1);
}
.hot .active{
    color:#0080CC
}
.citys{
    display:flex;
    align-items: center;
    flex-wrap: wrap;
}
.city{
    width:69px;
    height:30px;
    background:rgba(215,221,228,1);
    border-radius:2px;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height: 30px;
    margin-left:20px;
    margin-top:20px;
    text-align: center;
    cursor: pointer;
}
.city:hover{
  background:#acb4bd;
}
.city:nth-of-type(6n+1){
    margin-left: 0px;
}
.citys .active{
    background:rgba(0,128,204,1);
}
.remind{
   font-size:14px;
    font-weight:300;
    color:rgba(141,153,163,1);
    margin-left:8px;
}
.check{
    width:14px;
    height:14px;
    border-radius: 3px;
    box-sizing:border-box;
    border:1px solid #8D99A3;
}
.mgt20{
    margin-top:20px;
}
.bord{
    padding-bottom:20px;
    border-bottom: 1px solid #F0F0F0;
}
.sure{
    width:211px;
    height:44px;
    background:rgba(0,128,204,1);
    border-radius:3px;
    margin:20px auto;
    font-size:16px;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height:44px;
    text-align: center;
    cursor: pointer;
}
  .down{
    position: absolute;
    width:21.3125rem;
    z-index: 999999;
    background-color: #fff;
  }
  .sel{
    width:100%;
    margin:auto;
    height:2.9375rem;
    line-height: 2.9375rem;
    text-align:center;
    color:#9aa2aa;
    font-size:14px;
  }
  .sel:hover{
    background-color: #0080cc;
    color:#fff;
  }
  .active{
    background-color: #0080cc;
    color:#fff;
  }
  .inner{
    width:300px;
    margin:auto;
    border-bottom:1px solid #c6cbd0;
  }
  .sel:nth-last-child(1) .inner{
      border-bottom:0;
  }
.yhot{
    width:22px;
    height:11px;
    position: absolute;
    top:-5px;
    right:-5px;
 }
 .yhot img{
    width:22px;
    height:11px;
 }
 .btnns{
   height:49px;
 }
</style>



// WEBPACK FOOTER //
// src/views/recommendedRoute.vue